// components/ImageModal.tsx
import { XMarkIcon } from "@heroicons/react/24/solid";
import React, { forwardRef } from "react";

import ImageCropper from "./ImageCropper";

interface ImageModalProps {
  closeModal: () => void;
  onImageCropped: (file: File) => void;
}

const ImageModal = forwardRef<HTMLDivElement, ImageModalProps>(
  ({ closeModal, onImageCropped }, ref) => {
    return (
      <div ref={ref} className="relative z-10">
        <div className="fixed inset-0 transition-all bg-black/30" />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <div className="relative w-full max-w-4xl transform rounded-lg bg-white dark:bg-gray-800 text-left shadow-xl transition-all">
              <button
                className="cursor-pointer rounded-md p-1 inline-flex items-center justify-center text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 focus:outline-none absolute top-3 right-3 z-20"
                type="button"
                onClick={closeModal}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="w-6 h-6" />
              </button>
              <ImageCropper
                onCropComplete={(file) => {
                  onImageCropped(file);
                  closeModal();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  },
);

export default ImageModal;
